import React from 'react';
import cn from 'classnames';
import styles from './styles.css';

const LotStatusIcon = ({ className, status }) => {
  const lowerStatus = status.toLowerCase();
  const style = styles[lowerStatus] ? styles[lowerStatus] : styles.default;
  return <span className={cn(className, styles.container, style, 'dib br-100')} />;
};

export default LotStatusIcon;



// WEBPACK FOOTER //
// ./src/components/lotStatusIcon/lotStatusIcon.jsx